import React from 'react';
import styled from 'styled-components';
import { samplingRateTooltipOption } from '../../../KubitTooltip/globalTooltips';
import { SAMPLE_PERCENTAGE_VALUES } from '../../../../config/constants';
import * as BuilderUI from '../../BuilderUI';
import BuilderNumericalMenu from '../BuilderNumericalMenu';

interface IProps {
  value: number;
  onChange: (newValue: number) => void;
}

const Container = styled(BuilderUI.BuilderFieldContainer)`
  flex-shrink: 1;
`;

const SamplePercentageMenu = ({ value, onChange }: IProps) => {
  return (
    <Container>
      <BuilderNumericalMenu
        label="Sampling Rate"
        tooltipContent={samplingRateTooltipOption}
        value={value}
        options={SAMPLE_PERCENTAGE_VALUES.map((value) => ({
          text: `${value}%`,
          value,
        }))}
        max={100}
        placeholder="Enter a value"
        suffix="%"
        onChange={onChange}
      />
    </Container>
  );
};

export default SamplePercentageMenu;
